export function getCartUnitPrice(item) {
  return Number(item.product?.price || item.product?.rental_price || 0);
}

export function getCartDeliveryFee(item) {
  if (item.delivery_fee_per_unit != null) {
    return Number(item.delivery_fee_per_unit) * Number(item.quantity);
  }
  return Number(item.delivery_fee_total || 0);
}

// Require a second review when another tab or a price update changed the cart.
export function cartQuoteFingerprint(items) {
  return JSON.stringify(items.map(item => [
    item.id, Number(item.quantity), getCartUnitPrice(item), getCartDeliveryFee(item),
  ]).sort((left, right) => left[0] - right[0]));
}

export function cartOrderSnapshot(items) {
  return items.map(item => ({
    id: item.id,
    quantity: Number(item.quantity),
    unit_price: getCartUnitPrice(item),
    delivery_fee_per_unit: item.delivery_fee_per_unit != null
      ? Number(item.delivery_fee_per_unit) : getCartDeliveryFee(item) / Number(item.quantity),
  }));
}
